/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useRef, useEffect } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import ReactApexChart from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Dropdown, Menu } from "antd";
import { currencyFormat, downloadImageCommon, exportChatFile } from "../../../../helpers/utilities";
import { Tooltip, IconButton } from "@mui/material";
import infoMarkIcon from "../../../../assets/images/icon_actions/infoMark.svg";

export const Total = (props) => {
    const { title, sTitle, total_sales_15, total_sales_30, total_sales_90, toolTip } = props;
    const total = useRef(null);
    const [totalSale15, setTotalSales15] = useState('');
    const [totalSale30, setTotalSales30] = useState('');
    const [totalSale90, setTotalSales90] = useState('');

    useEffect(() => {
        setTotalSales15(total_sales_15);
        setTotalSales30(total_sales_30);
        setTotalSales90(total_sales_90);
    }, []);

    const classes = customStyles();
    const chartData = {
        chart: {
            type: 'area',
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: []
                }
            }
        },
        grid: {
            show: true,
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 10
            }
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '13px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return '<div class="arrow_box">' +
                    '<div class="invoice_amountss">₹ ' + currencyFormat(series[0][dataPointIndex]) + '</div>' +
                    '</div>';
            }
        },
        title: {
            text: undefined
        },
        markers: {
            size: 4,
            colors: ['#d20b0b'],
            strokeWidth: 0,
            fillOpacity: 1,
            shape: "circle",
            hover: {
                size: 4,
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: "11px",
                }
            },
            categories: ["15 Days", "30 Days", "90 Days"],
        },
        yaxis: {
            show: true,
            labels: {
                show: false,
            },

        },
        fill: {
            colors: ['#16c88b'],
            opacity: 1
        },
        stroke: {
            curve: 'straight',
        },
        series: [{
            color: "#16c88b",
            data: [totalSale15, totalSale30, totalSale90],
        }],
    };
    const chartData15 = {
        chart: {
            type: 'area',
            background: '#f5f5f5',
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                right: 20,
                blur: 3,
                color: '#000',
                opacity: 0.35
            },
            toolbar: {
                show: false
            },
        },
        grid: {
            show: true,
            padding: {
                top: -20,
                right: 0,
                bottom: 0
            }
        },
        title: {
            text: undefined,
            floating: true,
        },
        stroke: {
            curve: 'straight',
        },
        tooltip: {
            enabled: false,
        },
        markers: {
            discrete: [{
                seriesIndex: 0,
                dataPointIndex: 0,
                fillColor: '#d20b0b',
                fillOpacity: 1,
                strokeColor: 'transparent',
                size: 4,
                shape: "circle",
                hover: {
                    size: 4,
                },
            }]
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: "8px",
                }
            },
            categories: ["15 Days", "30 Days", "90 Days"],
        },
        yaxis: {
            show: true,
            labels: {
                show: false,
            },

        },
    };
    const chartData30 = {
        chart: {
            type: 'area',
            background: '#f5f5f5',
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                right: 20,
                blur: 3,
                color: '#000',
                opacity: 0.35
            },
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: []
                }
            },
        },
        grid: {
            show: true,
            padding: {
                top: -20,
                right: 0,
                bottom: 0
            }
        },
        title: {
            text: undefined,
            floating: true,
        },
        stroke: {
            curve: 'straight',
        },
        tooltip: {
            enabled: false,
        },
        markers: {
            discrete: [{
                seriesIndex: 0,
                dataPointIndex: 1,
                fillColor: '#d20b0b',
                strokeColor: 'transparent',
                size: 4,
                shape: "circle",
                hover: {
                    size: 4,
                },
            }]
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: "8px",
                }
            },
            categories: ["15 Days", "30 Days", "90 Days"],
        },
        yaxis: {
            show: true,
            labels: {
                show: false,
            },

        },
    };
    const chartData90 = {
        chart: {
            type: 'area',
            background: '#f5f5f5',
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                right: 20,
                blur: 3,
                color: '#000',
                opacity: 0.35
            },
            toolbar: {
                show: false,
            },
        },
        grid: {
            show: true,
            padding: {
                top: -20,
                right: 0,
                bottom: 0
            }
        },
        title: {
            text: undefined,
            floating: true,
        },
        stroke: {
            curve: 'straight',
        },
        tooltip: {
            enabled: false,
        },
        markers: {
            discrete: [{
                seriesIndex: 0,
                dataPointIndex: 2,
                fillColor: '#d20b0b',
                strokeColor: 'transparent',
                size: 4,
                shape: "circle",
                hover: {
                    size: 4,
                },
            }]
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: "8px",
                }
            },
            categories: ["15 Days", "30 Days", "90 Days"],
        },
        yaxis: {
            show: true,
            labels: {
                show: false,
            },

        },
    };

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(total.current, title, type);
        }
    }
    const exportFile = () => {
        let newHead = [
            ['15 Days', '30 Days', '90 Days'],
            [total_sales_15, total_sales_30, total_sales_90],
        ];
        exportChatFile(`${title}`, newHead);
    }

    return (
        <div ref={total} className={clsx(classes.totalChartDiv, classes.totalSalesCustom)}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}
                <Tooltip
                    classes={{ popper: classes.customToolTip }}
                    title={toolTip} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                    <IconButton>
                        <Image src={infoMarkIcon} preview={false} />
                    </IconButton>
                </Tooltip>
            </span>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={clsx(classes.overFolwBigContent, classes.scrollBarLight)} style={{ height: 'calc(100% - 24px)', marginTop: 5 }}>
                <div className={classes.positionRelative}>
                    <ReactApexChart height="160px" options={chartData} series={chartData.series} type="area" />
                </div>
                <div className={classes.groupChart}>
                    <Row gutter={10} className={classes.groupChartRow}>
                        <Col span={14}>
                            <div className={classes.groupChartSeperate}>
                                <ReactApexChart height="70" options={chartData15} series={chartData.series} type="area" />
                            </div>
                        </Col>
                        <Col span={10}>
                            <div className={clsx(classes.textAlignRight, classes.sales15Days, classes.bg_yellow)}>
                                <div className={classes.salesDays}>15 Days</div>
                                <div className={classes.bold}>{sTitle}</div>
                                <div className={classes.bold}>₹ {currencyFormat(total_sales_15)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={10} className={classes.groupChartRow}>
                        <Col span={14}>
                            <div className={classes.groupChartSeperate}>
                                <ReactApexChart height="70" options={chartData30} series={chartData.series} type="area" />
                            </div>
                        </Col>
                        <Col span={10}>
                            <div className={clsx(classes.textAlignRight, classes.sales15Days, classes.sales30Days, classes.bg_blue)}>
                                <div className={classes.salesDays}>30 Days</div>
                                <div className={classes.bold}>{sTitle}</div>
                                <div className={classes.bold}>₹ {currencyFormat(total_sales_30)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={10} className={classes.groupChartRow}>
                        <Col span={14}>
                            <div className={classes.groupChartSeperate}>
                                <ReactApexChart height="70" options={chartData90} series={chartData.series} type="area" />
                            </div>
                        </Col>
                        <Col span={10}>
                            <div className={clsx(classes.textAlignRight, classes.sales15Days, classes.sales90Days, classes.bg_green)}>
                                <div className={classes.salesDays}>90 Days</div>
                                <div className={classes.bold}>{sTitle}</div>
                                <div className={classes.bold}>₹ {currencyFormat(total_sales_90)}</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}